// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"420a1bd6","239":"152e2dd9","455":"c9d1ce43","488":"50a3fae0"}[chunkId] + ".chunk.js";
};